<template>
    <div class="searchRow">

        <div class="autosuggestContainer">
            <div
                role="combobox"
                aria-haspopup="listbox"
                aria-owns="react-autowhatever-1"
                aria-expanded="false"
                class="react-autosuggest__container">
                <input id="myInput3" class="react-autosuggest__input" type="text" v-model="$store.state.addr_comp_search" @focus="showAllItems" @input="filterList" placeholder="חפשו את הכתובת עליה תרצו עדכונים"
                @keydown.down="moveSelection(1)" 
                @keydown.up="moveSelection(-1)" 
                @keydown.enter="selectCurrentItemEnterKey" >

                <div v-if="filteredItems.length > 0" id="myInput_neighautocomplete-list" role="listbox" class="react-autosuggest__suggestions-container react-autosuggest__suggestions-container--open" data-font-size="10" data-font-size-type="px">
                    <ul role="listbox" class="react-autosuggest__suggestions-list">
                        <li 
                        v-for="(item, index) in filteredItems" 
                        :key="item.id" 
                        @click="selectItem(item)" 
                        role="option" 
                        :id="'react-autowhatever-1--item-' + index" 
                        :aria-selected="selectedIndex === index"
                        :class="['react-autosuggest__suggestion', {'react-autosuggest__suggestion--highlighted': selectedIndex === index}]"
                        :data-suggestion-index="index">
                        <div class="suggestionRow">
                          <span class="location">
                            <span v-html="highlightText(item.text, $store.state.addr_comp_search)"></span>
                          </span>
                          <span class="type">{{ types[item.type.toLowerCase()] }}</span>
                        </div>
                      </li>
                    </ul>
                </div>
            </div>
            <div class="magnifyWrap">
                <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    class="magnifyIcon"
                >
                    <title>search</title>
                    <g
                        id="search-24"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                    >
                        <rect
                            id="Rectangle"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                        ></rect>
                        <path
                            d="M18.0104076,15.5104076 L21.0104076,15.5104076 L21.0104076,22.0104076 C21.0104076,22.8388348 20.3388348,23.5104076 19.5104076,23.5104076 C18.6819805,23.5104076 18.0104076,22.8388348 18.0104076,22.0104076 L18.0104076,15.5104076 L18.0104076,15.5104076 Z"
                            id="Rectangle-hand"
                            fill="#000000"
                            transform="translate(19.510408, 19.510408) rotate(-45.000000) translate(-19.510408, -19.510408)"
                        ></path>
                        <circle
                            id="Oval"
                            stroke="#000000"
                            stroke-width="2"
                            cx="10.5"
                            cy="10.5"
                            r="8.5"
                        ></circle>
                    </g>
                </svg>
            </div>
        </div>
        <div class="forBtnWrapper">
            <div class="submitBtnWrapper">
                <button
                    @click="showResults(res)"
                    type="submit"
                    class="btn arrowBtn plusBtn"
                >
                    <span class="plus"></span>
                </button>
            </div>
            <div
                v-show="
                    $store.state.searchError == true && $store.state.addr_comp_search == ''
                "
                class="error centerd searchErr"
            >
                יש להזין כתובת תקינה
            </div>
        </div>

    </div>
</template>

<script>

//Vue component

export default {
  name: "SearchBoxUserAddresses",
  data() {
    return {
        res: {},
        selectedIndex: -1,
        types: {
                'address': 'כתובת', 'neighborhood': 'שכונה', 'street': 'רחוב', 
                'settlement': 'יישוב', 'parks': 'שמורות טבע וגנים', 'institutes': 'מוסדות', 
                'junction': 'צומת', 'block': 'גוש', 'parcel': 'חלקה', 'ways': 'דרכים', 
                'poi': 'נקודת עניין', 'statistic': 'איזור סטטיסטי'
        },
        items: [],
        filteredItems: [],

        showContactMsg: false,
        contactText: "",
    };
  },

  methods: {
    moveSelection(direction) {
      if (this.items.length === 0) return;

      this.selectedIndex += direction;

      // Ensure the selectedIndex wraps around appropriately
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.items.length - 1;
      } else if (this.selectedIndex >= this.items.length) {
        this.selectedIndex = 0;
      }

      // Optionally, scroll the selected item into view
      this.$nextTick(() => {
        const selectedElement = document.querySelector(
          `.react-autosuggest__suggestion[data-suggestion-index="${this.selectedIndex}"]`
        );
        if (selectedElement) {
          selectedElement.scrollIntoView({ block: 'nearest' });
        }
      });
    },
    selectCurrentItemEnterKey() {
        if ((this.selectedIndex >= 0 && this.selectedIndex < this.items.length) || this.items.length > 0) {
            if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
                this.selectItem(this.items[this.selectedIndex]);
            }
            else {
                // get item 0 if exists..
                if (this.items.length > 0) {
                    this.selectItem(this.items[0]);
                }
            }
        }
        else{
            if (this.res != {} ) {
                this.showResults(this.res);
                return;
            }

        }
    },
    selectCurrentItem() {
        if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
            this.selectItem(this.items[this.selectedIndex]);
        }
        else {
            // get item 0 if exists..
            if (this.items.length > 0) {
                this.selectItem(this.items[0]);
            }
        }
    },
    zoomCurrentLocation() {
        var appVue = this;
        appVue.$store.state.loading = true;
        appVue.mixin_zoomCurrentLocation(appVue);
    },
    highlightText(text, query) {
        // eslint-disable-next-line
        const sanitizedquery = query.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regex = new RegExp(`(${sanitizedquery})`, 'gi');
        return text.replace(regex, '<span class="highlight blue">$1</span>');
    },
    showAllItems() {
        this.filteredItems = this.items;
    },
    filterList() {
        if (this.$store.state.addr_comp_search === "" || this.$store.state.addr_comp_search == null) {
            return;
        }
        var url = "https://es.govmap.gov.il/TldSearch/api/DetailsByQuery?query=" + this.$store.state.addr_comp_search + "&lyrs=16399&gid=nadlan";

        fetch(url)
        .then(response => {
            if (!response.ok) {
                if (response.status === 404) {
                    // If the response is a 404, return without doing anything
                    return;
                }
                // For other errors, throw an error to be caught by the catch block
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            this.items = [];
            if (data.data.NEIGHBORHOOD) {
                data.data.NEIGHBORHOOD.forEach((item) => {
                    var obj = item;
                    //extend obj
                    obj.id = item.ObjectID;
                    obj.text = item.ResultLable;
                    obj.shape = `POINT(${item.X} ${item.Y})`;
                    obj.type = 'NEIGHBORHOOD';
                    this.items.push(obj);
                    // this.items.push({
                    //     id: item.ObjectID,
                    //     text: item.ResultLable,
                    //     type: 'NEIGHBORHOOD',
                    //     shape: `POINT(${item.X} ${item.Y})`
                    // });
                });
            }
            if (data.data.STREET) {
                data.data.STREET.forEach((item) => {
                    var obj = item;
                    //extend obj
                    obj.id = item.ObjectID;
                    obj.text = item.ResultLable;
                    obj.shape = `POINT(${item.X} ${item.Y})`;
                    obj.type = 'STREET';
                    this.items.push(obj);
                    // this.items.push({
                    //     id: item.ObjectID,
                    //     text: item.ResultLable,
                    //     type: 'STREET',
                    //     shape: `POINT(${item.X} ${item.Y})`
                    // });
                });
            }
            if (data.data.ADDRESS) {
                data.data.ADDRESS.forEach((item) => {
                    var obj = item;
                    //extend obj
                    obj.id = item.ObjectID;
                    obj.text = item.ResultLable;
                    obj.shape = `POINT(${item.X} ${item.Y})`;
                    obj.type = 'ADDRESS';
                    this.items.push(obj);

                    // this.items.push({
                    //     id: item.ObjectID,
                    //     text: item.ResultLable,
                    //     type: 'ADDRESS',
                    //     shape: `POINT(${item.X} ${item.Y})`
                    // });
                });
            }
            if (data.data.GOVMAP_PARCEL_ALL) {
                data.data.GOVMAP_PARCEL_ALL.forEach((item) => {
                    var obj = item;
                    //extend obj
                    obj.id = item.ObjectID;
                    obj.text = item.ResultLable;
                    obj.shape = `POINT(${item.X} ${item.Y})`;
                    obj.type = 'KPARCEL_ALL';
                    this.items.push(obj);
                    // this.items.push({
                    //     id: item.ObjectID,
                    //     text: item.ResultLable,
                    //     type: 'KPARCEL_ALL',
                    //     shape: `POINT(${item.X} ${item.Y})`
                    // });
                });
            }

            this.items.sort((a, b) => {
                if (a.type > b.type) {
                    return 1;
                }
                if (a.type < b.type) {
                    return -1;
                }
                return 0;
            });

            this.filteredItems = this.items;
        })
        .catch(() => {
            //console.error('Error:', error);
            return [];
        });
    },

    selectItem(item) {
        this.res = item;
        this.filteredItems = [];
        this.items = [];
        this.$store.state.addr_comp_search = item.text;		
    },
    async showResults(res) {
        var appVue = this;
        var addr_obj = {
            addressName: res.text,
            addressId: res.id,
            addressType: res.type,
            // polygonId: data.polygon_id,
            // settlementId: data.setl_id,
            // settlementName: data.setl_name,
            // neighborhoodId: data.neigh_id,
            // neighborhoodName: data.neigh_name
        };
        if (appVue.$store.state.config.search_baseUrl == "https://es.govmap.gov.il/TldSearch") {
            if (addr_obj.addressType == "NEIGHBORHOOD") {
                // convert neigh id
                
                addr_obj.addressId = appVue.$store.state.neigh[
                    addr_obj.addressId
                                ].UNIQ_ID_OLD;
            }
        }
        this.$parent.addrToAdd = addr_obj;
        this.$parent.addAddress();
    },
},
  computed: {
    appVue_or_homeView(){
        // get the parent component
        return this.$parent.$options.name;
    },
    isMobile() {
        return window.innerWidth < 1024;
    },
    searchMobileActive() {
        return this.$parent.searchMobileActive;
    },
  },
};

</script>


<style scoped>

.react-autosuggest__suggestion--highlighted {
    background-color: #f0f0f0;
  }

  .arrowBtn {
    transition: none;
  }
  .arrowWrap {
    transition: none;
  }

  </style>  

